import type { CustomerPortfolio } from '~models/CustomerPortfolio/CustomerPortfolioModel';
import { showCustomerPortfolio } from '~/services/apiCustomerPortfolio.js';
import { useAuthStore } from '~stores/useAuthStore';

export const useCustomerPortfolioStore = defineStore(
  'MY_SCAN_SOURCE_CUSTOMER_PORTFOLIO_STORE',
  () => {
    const AUTH_STORE = useAuthStore();

    const customerPortfolio = ref<CustomerPortfolio>();
    const loadingPortfolio = ref(false);

    const salesPerson = computed(() => customerPortfolio.value?.salesPerson);
    const responsible = computed(() => customerPortfolio.value?.responsible);
    const contacts = computed(() => customerPortfolio.value?.contacts);
    const isLoadingPortfolio = computed(() => loadingPortfolio.value);

    const hasNoContacts = computed(() => !customerPortfolio.value);

    function setCustomerPortfolio(data: CustomerPortfolio | undefined) {
      customerPortfolio.value = data;
    }

    async function dispatchShowCustomerPortfolio() {
      loadingPortfolio.value = true;
      await showCustomerPortfolio(AUTH_STORE.session.currentEconomicGroupMember)
        .then(
          (portfolio: CustomerPortfolio) => {
            setCustomerPortfolio(portfolio);
          },
          (error: any) => {
            console.error('Error fetching customer portfolio:', error);
            setCustomerPortfolio(undefined);
          },
        )
        .finally(() => {
          loadingPortfolio.value = false;
        });
    }

    return {
      customerPortfolio,
      salesPerson,
      responsible,
      contacts,
      hasNoContacts,
      isLoadingPortfolio,
      setCustomerPortfolio,
      dispatchShowCustomerPortfolio,
      onChangeEconomicGroup: () => dispatchShowCustomerPortfolio(),
      onSessionOpen: () => dispatchShowCustomerPortfolio(),
    };
  },
);
